import { Controller } from '@hotwired/stimulus';

const TOLERANCE = 24;

export default class extends Controller {
  static values = { running: Boolean };

  #pinned = false;

  #observer = null;

  connect() {
    this.#pinned = this.runningValue;

    if (this.#pinned) this.#scrollToBottom();

    this.#observer = new MutationObserver(() => this.#follow());
    this.#observer.observe(this.element, { childList: true, subtree: true });
  }

  disconnect() {
    this.#observer?.disconnect();
    this.#observer = null;
  }

  measure() {
    this.#pinned = this.#distanceFromBottom <= TOLERANCE;
  }

  #follow() {
    if (this.#pinned) this.#scrollToBottom();
  }

  get #distanceFromBottom() {
    return this.element.scrollHeight - this.element.scrollTop - this.element.clientHeight;
  }

  #scrollToBottom() {
    this.element.scrollTop = this.element.scrollHeight;
  }
}
